import { Injectable, inject } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BookingRequest } from "../general/models/booking-request.model";

@Injectable({
  providedIn: 'root'
})
export class BookingService {
    private http = inject(HttpClient);

    private apiUrl = environment.apiUrl;

    submitBookingRequest(request: BookingRequest): Observable<any> {
        return this.http.post(`${this.apiUrl}/booking`, request);
    }

}